import React from 'react'
import { AuthInitializer } from '../AuthInitializer'
import { GeneralLayoutComponent } from '../GeneralLayout'
import { DirectionSync } from '@/modules/i18n'
import { LanguageSync } from '../LanguageSync'
import { UILabelsFromI18n } from '../ui/UILabelsFromI18n'
import { isDebugDev } from '@/store/debugAtoms'
import { useTar } from '@/modules/i18n'
import { UIConfigProvider } from '@duck/ui'
import { Provider as DirectionProvider } from '@radix-ui/react-direction'

interface LayoutProps {
  children: React.ReactNode;
}

(() => {
  if (isDebugDev) {
    const env = import.meta.env
    console.log('import.meta.env', env)
  }
})()

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isRtl } = useTar()

  return (
    <>
      <DirectionSync />
      <LanguageSync />
      <DirectionProvider dir={isRtl ? 'rtl' : 'ltr'}>
        <UIConfigProvider value={{ isRTL: isRtl }}>
          <UILabelsFromI18n>
            <AuthInitializer>
              <GeneralLayoutComponent>
                {children}
              </GeneralLayoutComponent>
            </AuthInitializer>
          </UILabelsFromI18n>
        </UIConfigProvider>
      </DirectionProvider>
    </>
  )
}
